<script lang="ts">
	import Basic from '../templates/Basic.svelte'

	// Bettet die SaaS-Seite des AI-Dashboards (über den Spring-Proxy) per iframe in die
	// MM-Oberfläche ein. ?embed=1 unterdrückt die Dashboard-eigene Navigation; der Zugriff
	// und das Tenant-Scoping (eigenes Unternehmen) werden serverseitig erzwungen.
	let iFrameLoaded = false
</script>

<Basic fullscreen iFrameUrl="/ai-dashboard/saas">
	<div class="ai-dashboard-saas-frame">
		<iframe
			src="/ai-dashboard/saas?embed=1"
			title="AI-Dashboard"
			on:load={() => (iFrameLoaded = true)}
		></iframe>
	</div>
	<!-- Hint for selenide tests -->
	{#if iFrameLoaded}
		<div id="iFrameLoaded"></div>
	{/if}
</Basic>

<style lang="scss">
	.ai-dashboard-saas-frame {
		width: 100%;
		height: 100%;
	}

	iframe {
		display: block;
		border: 0;
		width: 100%;
		height: 100%;
	}
</style>
